import * as React from 'react';

import { assert } from '@gitbook/util-ts';

export type SegmentedControlContextType = {
    isSelected: boolean;
};

const SegmentedControlContext = React.createContext<SegmentedControlContextType | null>(null);

export function SegmentedControlContextProvider({
    children,
    value,
}: {
    children: React.ReactNode;
    value: SegmentedControlContextType;
}) {
    return (
        <SegmentedControlContext.Provider value={value}>
            {children}
        </SegmentedControlContext.Provider>
    );
}

export function useSegmentedControlContext() {
    const context = React.useContext(SegmentedControlContext);
    assert(context, 'Must be used within a SegmentedControlContextProvider');
    return context;
}
